/**
 * LoginLogoSection
 * @author omriha
 * 15/10/2019
 */
 import React from 'react';
 import loginFigureLogo from '../../assets/images/login/quantum.svg';
 import cpLogo from '../../assets/images/cp-logo.png';
 
 /**
  * Company login logo
  */
 export default function LoginLogoSection(){
     return (
         <div>
             <img src={loginFigureLogo} className="loginFigure" alt="Quantum Spark SMP" />
             <div className="loginFigureProductName">
                 <b>QUANTUM SPARK</b>
                 <br />
                 <span>SECURITY MANAGEMENT PORTAL</span>
             </div>
             <div className="loginCPLogoContainer" style={{left:"auto",right:"410px",margin:"0 80px"}}> 
                 <div style={{ lineHeight: "100%"}}>
                     <img width="160" src={cpLogo} alt="Check Point" />
                 </div>
             </div>
         </div>
     );
 }